// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { recentQuotesStyles } from "@conklin/Overrides/Widgets/Common/RecentQuotes";
import { linkArrowStyle, xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

recentQuotesStyles.wrapper = {
    css: css`
        display: flex;
        flex: 1;
        flex-direction: column;
        row-gap: 12px;
        .notify {
            margin-bottom: 0;
        }
    `,
};

recentQuotesStyles.viewAllLink = {
    ...linkArrowStyle("small", {
        css: css`
            && {
                ${xScreen("lte", "md")} {
                    display: none;
                }
            }
        `,
    }),
};

recentQuotesStyles.specificWidthDataTableHeader = {
    css: css`
        width: 150px;
    `,
};
